import httpApiApplication from '../../../../../http/httpApiApplication';

import { type ReportVersion } from './types';

export const baseUrl = '/reportversion';
export function update(id: string, request: ReportVersion) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function remove(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}
export function GetReportById(reportId: string, anio: number, periodicity: string) {
  const periodicityHeader = periodicity ? '?headerPeriodicity=' + periodicity : '';

  return httpApiApplication.get(`${baseUrl}/last/${reportId}/${anio}${periodicityHeader}`);
}
export const create = (request: ReportVersion) => {
  return httpApiApplication.post(baseUrl, request);
};
